module.exports = __webpack_public_path__ + "static/media/playbutton.df8d4588.png";